<section *ngIf="!model.Hidden"
    #section
    class="sm-form-section"
    [id]="'FormSection:' + model.Id"  
    [ngClass]="{ 'section-readOnly': readOnly }">
    <div class="section--header">
        <div class="top">
            <div *ngIf="hasError" class="section--status_icon">
                <aurora-icon icon="warning"></aurora-icon>
            </div>
            <h2>
                {{model.Label}} 
                <span *ngIf="model.Repeatable">
                    ({{ repeatableInstanceCount }})
                </span>
                <aurora-icon-button *ngIf="!readOnly && model.Repeatable && model.Access != 'PreventAddAndDelete'" 
                    [disabled]="model.ParentIsDeleted"
                    [attr.id]="'FormSection:' + model.Id + ':AddSection'"  
                    class="add" 
                    icon="plus"
                    variant="ghost"
                    aria-label="Add section"
                    (click)="onSectionAdded.emit(this.model)">
                </aurora-icon-button>
            </h2>
            <aurora-icon-button *ngIf="!hideSingleSectionArrow && !model.ToggledToHide" [attr.id]="'FormSectionCollapse:' + model.Id"  
                class="toggle_all" icon="chevron-up" variant="ghost" title="Toggle all nested sections" aria-label="Toggle all nested sections"
                (click)="model.ToggledToHide = true">
            </aurora-icon-button>
            <aurora-icon-button *ngIf="!hideSingleSectionArrow && model.ToggledToHide" [attr.id]="'FormSectionExpand:' + model.Id"
                class="toggle_all" icon="chevron-down" variant="ghost" title="Toggle all nested sections" aria-label="Toggle all nested sections"
                (click)="model.ToggledToHide = false">
            </aurora-icon-button>
        </div>
        <div class="message" *ngIf="!readOnly">
            <small *ngIf="minInstanceError" class="text-danger">minimum of {{model.MinRepeatableInstances}} required</small>
            <small *ngIf="maxInstanceError" class="text-danger">maximum of {{model.MaxRepeatableInstances}} allowed</small>
        </div>
        <p *ngIf="model.Description">{{ model.Description }}</p>
    </div>
    <div class="section--body" *ngIf="!model.ToggledToHide">
        <ng-container *ngIf="!model.Repeatable">
            <div *ngFor="let item of model.Items">
                <ng-container *ngIf="item.ElementType === 'Section'">
                    <sm-form-section 
                        [model]="item" 
                        [readOnly]="readOnly"
                        [hideSingleSectionArrow]="hideSingleSubSectionArrow"
                        [formState]="formState"
                        (onValueChanged)="onValueChanged.emit($event)"
                        (onSectionAdded)="onSectionAdded.emit($event)"
                        (onSectionDeleted)="onSectionDeleted.emit($event)"
                        (onDetectChanges)="updateStatuses()">
                    </sm-form-section>
                </ng-container>
                <ng-container *ngIf="item.ElementType === 'Field'">
                    <sm-form-field 
                        [model]="item" 
                        [readOnly]="readOnly"
                        [formState]="formState"
                        (onValueChanged)="onValueChanged.emit($event)"
                        (onDetectChanges)="updateStatuses()">
                    </sm-form-field>
                </ng-container>
                <ng-container *ngIf="item.ElementType === 'StaticText'">
                    <sm-form-static-element 
                        [model]="item">
                    </sm-form-static-element>
                </ng-container>
                <ng-container *ngIf="item.ElementType === 'Row'">
                    <sm-form-row
                        [model]="item" 
                        [readOnly]="readOnly"
                        [formState]="formState"
                        (onValueChanged)="onValueChanged.emit($event)"
                        (onDetectChanges)="updateStatuses()">
                    </sm-form-row>
                </ng-container>
            </div> 
        </ng-container>
        <ng-container *ngIf="model.Repeatable">
            <table>
                <thead>
                    <tr>
                        <th *ngFor="let visibleLabel of model.RepeatableVisibleLabels; let i=index">
                            <div [ngClass]="{ 'first-column' : i == 0 }">
                                {{visibleLabel}}
                                <aurora-icon-button variant="ghost" [active]="currentSortLabel == visibleLabel" aria-label="Sort"
                                    [attr.icon]="currentSortLabel != visibleLabel ? 'sort' : (currentSortOrder == 'asc' ? 'sort-asc' : 'sort-des')"
                                    (click)="onChangeSort(visibleLabel)">
                                </aurora-icon-button>
                            </div>
                        </th>
                        <th>
                            <div>
                                <aurora-icon-button *ngIf="instancesHasChildSection && !allInstancesToggledToHide"
                                    [attr.id]="'FormSection:' + model.Id + ':ToggleAllToHide'"
                                    class="toggle_all"
                                    icon="chevrons-up"
                                    variant="ghost"
                                    title="Toggle all sections"
                                    aria-label="Toggle all sections"
                                    (click)="toggleAllInstances(true)">
                                </aurora-icon-button>
                                <aurora-icon-button *ngIf="instancesHasChildSection && allInstancesToggledToHide"
                                    [attr.id]="'FormSection:' + model.Id + ':ToggleAllToShow'"
                                    class="toggle_all"
                                    icon="chevrons-down"
                                    variant="ghost"
                                    title="Toggle all sections"
                                    aria-label="Toggle all sections"
                                    (click)="toggleAllInstances(false)">
                                </aurora-icon-button>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="!model.Instances?.length" class="zero">
                        <td [attr.colspan]="model.RepeatableVisibleLabels.length + 1">
                            <div><i>No {{model.Label}} records</i></div>
                        </td>
                    </tr>
                    <ng-container *ngFor="let instance of model.Instances">
                        <sm-form-section-instance
                            [model]="instance"
                            [readOnly]="readOnly"
                            [labels]="model.RepeatableVisibleLabels"
                            [parentId]="model.Id"
                            [formState]="formState"
                            (onValueChanged)="onValueChanged.emit($event)"
                            (onSectionAdded)="onSectionAdded.emit($event)"
                            (onSectionDeleted)="onSectionDeleted.emit($event)"
                            (onDetectChanges)="updateStatuses()"
                        >
                        </sm-form-section-instance>
                    </ng-container>        
                </tbody>
            </table>  
        </ng-container>                   
    </div>
</section>